import { Lang, Team } from '@brg/api';
import { ModerationType } from 'shared/pages/teams/const/ModerationTypes';
import { ManualRepostObject, RepostType } from 'shared/pages/teams/const/RepostType';
import { generateRepostObject } from 'shared/pages/teams/helpers/generateRepostObject';

/** Идентификатор «вкладки» для mainFilter, когда у организации нет tabs */
export const MAIN_FILTER_REPOST_PATH = '__main__';

export const isFilledTab = (tab: any) => {
    const isManualFilter = tab.filter?.usingFilterOrManual === false;
    const hasProjectIntoTab = tab.filter?.projectsShortInfos?.length > 0;
    const missingFilterProperty = !tab.filter?.hasOwnProperty('usingFilterOrManual');
    const emptyEntityType = tab?.entityType?.length === 0;
    
    if (isManualFilter) {
        return true;
    }
    if (hasProjectIntoTab && missingFilterProperty && emptyEntityType) {
        return true;
    }
    return false;
}

export const hasOrganizationTabs = (team?: Team<'Global'> | null): boolean => {
    if (team?.isShowTabs) {
        return Array.isArray(team?.tabs) && team.tabs.length > 0;
    }
    return false
}

export const isProjectInOrganization = (team: Team<'Global'>, projectId: string): boolean => {
    if (hasOrganizationTabs(team)) {
        return team.tabs!.some((tab) => tab?.filter?.projectIds?.includes(projectId));
    }

    return !!team.mainFilter?.projectsShortInfos?.some((item: any) => item.projectId === projectId);
};

export const isProjectInOrganizationTarget = (
    team: Team<'Global'>,
    projectId: string,
    targetPath: string,
): boolean => {
    if (hasOrganizationTabs(team)) {
        const tab = team.tabs!.find((item) => item.path === targetPath);
        return !!tab?.filter?.projectsShortInfos?.some((item: any) => item.projectId === projectId);
    }

    return targetPath === MAIN_FILTER_REPOST_PATH
        && !!team.mainFilter?.projectShortInfo?.some((item: any) => item.projectId === projectId);
};

export const addProjectToOrganization = (
    team: Team<'Global'>,
    projectId: string,
    targetPath: string,
): Team<'Global'> => {
    if (hasOrganizationTabs(team)) {
        return {
            ...team,
            tabs: team.tabs!.map((tab) => {
                if (tab.path !== targetPath) {
                    return tab;
                }

                return {
                    ...tab,
                    filter: {
                        ...tab.filter,
                        // projectIds: uniqueProjectIds([
                        //     ...(tab.filter?.projectIds || []),
                        //     projectId,
                        // ]),
                        projectsShortInfos: [
                            ...(tab.filter?.projectsShortInfos || []),
                            generateRepostObject(projectId, RepostType.repost),
                        ]
                    },
                };
            }),
        };
    }

    return {
        ...team,
        mainFilter: {
            ...team.mainFilter,
            // projectIds: uniqueProjectIds([
            //     ...(team.mainFilter?.projectIds || []),
            //     projectId,
            // ]),
            projectsShortInfos: [
                ...(team.mainFilter?.projectsShortInfos || []),
                generateRepostObject(projectId, RepostType.repost),
            ]
        },
    };
};

export const removeProjectFromOrganization = (
    team: Team<'Global'>,
    projectId: string,
    targetPath: string,
): Team<'Global'> => {
    if (hasOrganizationTabs(team)) {
        return {
            ...team,
            tabs: team.tabs!.map((tab) => {
                if (tab.path !== targetPath) {
                    return tab;
                }

                return {
                    ...tab,
                    filter: {
                        ...tab.filter,
                        // projectIds: (tab.filter?.projectIds || []).filter((id) => id !== projectId),
                        projectsShortInfos: (tab.filter?.projectsShortInfos || []).filter((item: ManualRepostObject) => item.projectId !== projectId),
                    },
                };
            }),
        };
    }

    return {
        ...team,
        mainFilter: {
            ...team.mainFilter,
            // projectIds: (team.mainFilter?.projectIds || []).filter((id) => id !== projectId),
            projectsShortInfos: (team.mainFilter?.projectsShortInfos || []).filter((item: ManualRepostObject) => item.projectId !== projectId),
        },
    };
};

export const getOrganizationRepostOptions = (
    team: Team<'Global'>,
    moderationType: ModerationType,
    language: string,
) => {
    if (hasOrganizationTabs(team)) {
        if (moderationType === ModerationType.Outer) {
            return team.tabs!.reduce<Array<{ label: string; value: string }>>((acc, tab) => {
                if (isFilledTab(tab)) {
                    acc.push({
                        label: Lang(tab.name, language),
                        value: tab.path,
                    });
                }
                return acc;
            }, []);
        }

        return team.tabs!.map((tab) => ({
            label: Lang(tab.name, language),
            value: tab.path,
        }));
    }

    const canUseMainFilter = moderationType === ModerationType.Outer
        ? team.mainFilter?.usingFilterOrManual === false
        : true;

    if (!canUseMainFilter) {
        return [];
    }

    return [{
        label: Lang(team.name, language),
        value: MAIN_FILTER_REPOST_PATH,
    }];
};

export const resolveOrganizationTargetLabel = (
    team: Team<'Global'>,
    targetPath: string,
    language: string,
): string => {
    if (hasOrganizationTabs(team)) {
        const tab = team.tabs!.find((item) => item.path === targetPath);
        return tab ? Lang(tab.name, language) : targetPath;
    }

    return Lang(team.name, language);
};
import { Lang, Team } from '@brg/api';
import { ModerationType } from 'shared/pages/teams/const/ModerationTypes';
import { ManualRepostObject, RepostType } from 'shared/pages/teams/const/RepostType';
import { generateRepostObject } from 'shared/pages/teams/helpers/generateRepostObject';

/** Идентификатор «вкладки» для mainFilter, когда у организации нет tabs */
export const MAIN_FILTER_REPOST_PATH = '__main__';

export const isFilledTab = (tab: any) => {
    const isManualFilter = tab.filter?.usingFilterOrManual === false;
    const hasProjectIntoTab = tab.filter?.projectsShortInfos?.length > 0;
    const missingFilterProperty = !tab.filter?.hasOwnProperty('usingFilterOrManual');
    const emptyEntityType = tab?.entityType?.length === 0;
    
    if (isManualFilter) {
        return true;
    }
    if (hasProjectIntoTab && missingFilterProperty && emptyEntityType) {
        return true;
    }
    return false;
}

export const hasOrganizationTabs = (team?: Team<'Global'> | null): boolean => {
    if (team?.isShowTabs) {
        return Array.isArray(team?.tabs) && team.tabs.length > 0;
    }
    return false
}

export const isProjectInOrganization = (team: Team<'Global'>, projectId: string): boolean => {
    if (hasOrganizationTabs(team)) {
        return team.tabs!.some((tab) => tab?.filter?.projectIds?.includes(projectId));
    }

    return !!team.mainFilter?.projectsShortInfos?.some((item: any) => item.projectId === projectId);
};

export const isProjectInOrganizationTarget = (
    team: Team<'Global'>,
    projectId: string,
    targetPath: string,
): boolean => {
    if (hasOrganizationTabs(team)) {
        const tab = team.tabs!.find((item) => item.path === targetPath);
        return !!tab?.filter?.projectsShortInfos?.some((item: any) => item.projectId === projectId);
    }

    return targetPath === MAIN_FILTER_REPOST_PATH
        && !!team.mainFilter?.projectShortInfo?.some((item: any) => item.projectId === projectId);
};

export const addProjectToOrganization = (
    team: Team<'Global'>,
    projectId: string,
    targetPath: string,
): Team<'Global'> => {
    if (hasOrganizationTabs(team)) {
        return {
            ...team,
            tabs: team.tabs!.map((tab) => {
                if (tab.path !== targetPath) {
                    return tab;
                }

                return {
                    ...tab,
                    filter: {
                        ...tab.filter,
                        // projectIds: uniqueProjectIds([
                        //     ...(tab.filter?.projectIds || []),
                        //     projectId,
                        // ]),
                        projectsShortInfos: [
                            ...(tab.filter?.projectsShortInfos || []),
                            generateRepostObject(projectId, RepostType.repost),
                        ]
                    },
                };
            }),
        };
    }

    return {
        ...team,
        mainFilter: {
            ...team.mainFilter,
            // projectIds: uniqueProjectIds([
            //     ...(team.mainFilter?.projectIds || []),
            //     projectId,
            // ]),
            projectsShortInfos: [
                ...(team.mainFilter?.projectsShortInfos || []),
                generateRepostObject(projectId, RepostType.repost),
            ]
        },
    };
};

export const removeProjectFromOrganization = (
    team: Team<'Global'>,
    projectId: string,
    targetPath: string,
): Team<'Global'> => {
    if (hasOrganizationTabs(team)) {
        return {
            ...team,
            tabs: team.tabs!.map((tab) => {
                if (tab.path !== targetPath) {
                    return tab;
                }

                return {
                    ...tab,
                    filter: {
                        ...tab.filter,
                        // projectIds: (tab.filter?.projectIds || []).filter((id) => id !== projectId),
                        projectsShortInfos: (tab.filter?.projectsShortInfos || []).filter((item: ManualRepostObject) => item.projectId !== projectId),
                    },
                };
            }),
        };
    }

    return {
        ...team,
        mainFilter: {
            ...team.mainFilter,
            // projectIds: (team.mainFilter?.projectIds || []).filter((id) => id !== projectId),
            projectsShortInfos: (team.mainFilter?.projectsShortInfos || []).filter((item: ManualRepostObject) => item.projectId !== projectId),
        },
    };
};

export const getOrganizationRepostOptions = (
    team: Team<'Global'>,
    moderationType: ModerationType,
    language: string,
) => {
    if (hasOrganizationTabs(team)) {
        if (moderationType === ModerationType.Outer) {
            return team.tabs!.reduce<Array<{ label: string; value: string }>>((acc, tab) => {
                if (isFilledTab(tab)) {
                    acc.push({
                        label: Lang(tab.name, language),
                        value: tab.path,
                    });
                }
                return acc;
            }, []);
        }

        return team.tabs!.map((tab) => ({
            label: Lang(tab.name, language),
            value: tab.path,
        }));
    }

    const canUseMainFilter = moderationType === ModerationType.Outer
        ? team.mainFilter?.usingFilterOrManual === false
        : true;

    if (!canUseMainFilter) {
        return [];
    }

    return [{
        label: Lang(team.name, language),
        value: MAIN_FILTER_REPOST_PATH,
    }];
};

export const resolveOrganizationTargetLabel = (
    team: Team<'Global'>,
    targetPath: string,
    language: string,
): string => {
    if (hasOrganizationTabs(team)) {
        const tab = team.tabs!.find((item) => item.path === targetPath);
        return tab ? Lang(tab.name, language) : targetPath;
    }

    return Lang(team.name, language);
};
